<template>
    <div>
        <form class="search">
            <button><img src="../../images/icons/search.svg" :alt="search_translation.title"></button>
            <input
                type="search"
                :placeholder="search_translation.placeholder + '...'"
                name="q"
                autocomplete="off"
                v-model="searchterm"
                id="teamSearchInput"
            >
        </form>
        <message-component v-if="showError" :status="errorStatus" :message="errorMessage"></message-component>
        <ul class="clubs">
            <team-list-item-component
                v-for="team in filteredTeams"
                v-bind:team="team"
                v-bind:key="team.contestant_id"
                v-bind:team_base_route="team_base_route"
            ></team-list-item-component>
        </ul>
        <div :class="{'is-loading is-loading-dark': isLoading}"></div>
    </div>
</template>

<script>
    import axios from 'axios'
    import TeamListItemComponent from './TeamListItemComponent.vue'
    export default {
        components: { TeamListItemComponent },
        props: ['search', 'message_error', 'message_no_results', 'tournament_id', 'team_base_route', 'search_translation'],
        data() {
            return {
                teams: [],
                searchterm: this.search,
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                isLoading: true
            }
        },
        computed: {
            endpoint: function() {
                if (typeof this.tournament_id !== 'undefined' && this.tournament_id) {
                    return '/api/teams/' + this.tournament_id;
                }
                return '/api/teams';
            },
            filteredTeams: function () {
                let search = this.searchterm.toLowerCase();

                let teams = this.teams.filter(function (team) {
                    return (team.name.toLowerCase().indexOf(search.toLowerCase()) != -1) ||
                        (team.short_name && team.short_name.toLowerCase().indexOf(search.toLowerCase()) != -1) ||
                        (team.club_name.toLowerCase().indexOf(search.toLowerCase()) != -1) ||
                        (team.code && team.code.toLowerCase().indexOf(search.toLowerCase()) != -1)
                }).sort(function (a, b) {
                    if (a.club_name < b.club_name)
                        return -1;
                    if (a.club_name > b.club_name)
                        return 1;
                    return 0;
                });
                if (teams.length == 0) {
                    this.showError = true;
                    this.errorStatus = 'generic';
                    this.errorMessage = this.message_no_results;
                } else {
                    this.showError = false;
                }
                return teams;
            }
        },
        mounted() {
            this.showError = false;
            this.$nextTick(function () {
                axios.get(this.endpoint).then((response) => {
                    this.isLoading = false;
                    this.teams = response.data;
                }).catch((response) => {
                    this.errorStatus = 'error';
                    this.errorMessage = this.message_error;
                    this.showError = true;
                });
            });
        },
        watch: {
            search(value) {
                this.searchterm = value;
            }
        }
    }
</script>
